import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItemsAuditRecord,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';

const RiskReviewAttendeesRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const propArray = ['InUse', 'OrgKey'];

    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
    };
    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, propArray),
    };

    const items = getFieldChangeItemsAuditRecord(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { RiskReviewAttendeesRecordChangeGrid };
